// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Item__container-e417d6 {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.Item__button-eab2a0 {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/main/SharedData/components/GroupByDateItems/Item/styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AACF;;AAEA;EACE,WAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n\n.button {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Item__container-e417d6`,
	"button": `Item__button-eab2a0`
};
module.exports = ___CSS_LOADER_EXPORT___;
